* {
  box-sizing: border-box;
}

:host {
  display: block;
  // Stretch the progress bar to max width of the container
  // The bar does not try to stretch by default
  width: 100%;
}
